export default "/" + Playtech.Variables.themeName + "/js/app-out/img/js__components__common__Game__images__gameStudios__origins.svg" + window.location.search;